import { render, staticRenderFns } from "./addRewardItem.vue?vue&type=template&id=c4ee0822&scoped=true&"
import script from "./addRewardItem.vue?vue&type=script&lang=js&"
export * from "./addRewardItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4ee0822",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\drone_race_manage\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c4ee0822')) {
      api.createRecord('c4ee0822', component.options)
    } else {
      api.reload('c4ee0822', component.options)
    }
    module.hot.accept("./addRewardItem.vue?vue&type=template&id=c4ee0822&scoped=true&", function () {
      api.rerender('c4ee0822', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/divisionManage/divisionAllController/component/addRewardItem.vue"
export default component.exports